KROWN.themeName = 'Split';
KROWN.themeVersion = '4.0.4';

const executeOnceOnDomContentLoaded = ()=>{

  // tab navigation

  let activeElement = document.activeElement;
  document.addEventListener('keyup', e=>{
    if ( e.keyCode == window.KEYCODES.TAB ) {
      if ( activeElement.classList.contains('focus') && e.target != activeElement ) {
        activeElement.classList.remove('focus');
      }
      if ( e.target.classList.contains('product-variant__input') ||
      	e.target.classList.contains('button') ||
      	e.target.classList.contains('product-item') ||
      	e.target.classList.contains('spr-summary-actions-newreview') ||
      	e.target.classList.contains('site-box-content-to-focus')
      ) {
        e.target.classList.add('focus');
      } 
      activeElement = document.activeElement;
    }
  });

  // newsletter has jump

  if ( window.location.pathname.includes('/challenge') ) {
    setTimeout(()=>{
      window.scroll({
        top: 0, 
        behavior: 'auto'
      });
    }, 300);
  }

  // fix image link borders

  document.querySelectorAll('.rte a img').forEach(elm=>{
    elm.parentNode.style.border = 'none';
  });

  // Filter handle
  
  if ( document.getElementById('site-filter-handle') ) {
    document.getElementById('site-filter-handle').addEventListener('click', e=>{
      e.preventDefault();
      document.getElementById('site-filters').show();
      document.getElementById('site-filter-handle').setAttribute('aria-expanded', 'true');
    });
  }

  // fix quick add to cart

  setTimeout(()=>{
    if ( document.querySelector('modal-box quick-view-product') ) {
      document.querySelector('modal-box quick-view-product').init();
    }
    if ( document.querySelector('modal-box quick-add-to-cart') ) {
      document.querySelector('modal-box quick-add-to-cart').init();
      document.querySelector('modal-box product-form').init();
    }
  }, 3050);

  // show newsletter popup confimation

  if ( document.location.search == '?customer_posted=true' && document.location.hash == '#newsletter-popup' && document.getElementById('modal-popup') ) {
    const newsletterPopup = document.getElementById('modal-popup');
    newsletterPopup.show();
    localStorage.setItem(newsletterPopup._modalKey, JSON.stringify({
      'shown': (new Date().getTime()),
      'content': newsletterPopup._modalText
    }));	
    setTimeout(()=>{
      newsletterPopup.querySelectorAll('[data-js-close]').forEach(elm=>elm.addEventListener('click',()=>{newsletterPopup.hide(true)}));
    }, 100);
    clearTimeout(newsletterPopup._modalTimeout);
  }

  // custom cart listener
  
  if ( document.querySelector('cart-form') ) {
    document.querySelector('cart-form').addEventListener('cart-updated', ()=>{
      if ( document.body.classList.contains('template-cart') ) {

        if ( document.querySelector('#AjaxCartForm .subtitle') ) {
          document.querySelector('#section-cart .box__heading .subtitle').innerHTML = document.querySelector('#AjaxCartForm .subtitle').innerHTML;
        }
        if ( document.getElementById('AjaxCartSubtotal').querySelector('[data-cart-empty]') ) {
          document.querySelector('#section-cart .box__heading .subtitle').innerHTML = "";
          if ( ! document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content') ) {
            document.getElementById('AjaxCartSubtotal').append(document.getElementById('section-cart').querySelector('template').content.cloneNode(true))
          } else {
            document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content').style.display = 'block';
          }
        } else if ( document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content') ) {
          document.getElementById('AjaxCartSubtotal').querySelector('.main-cart-empty-content').style.display = 'none';
        }

      }

      if ( document.querySelector('cart-recommendations') && parseInt(document.querySelector('[data-cart-count]').textContent ) == 0 ) {
        document.querySelector('cart-recommendations').innerHTML = '';
      }

    });
  }

  // recommended products listener

  if ( document.querySelector('#main-product-recommendations') ) {
    document.querySelector('#main-product-recommendations').addEventListener('product-recommendations-loaded', ()=>{
      eval(document.querySelector('#main-product-recommendations .js-fix-height').textContent);
    });
  }

}

if ( document.readyState !== 'loading' ) {
  executeOnceOnDomContentLoaded();
} else {
  document.addEventListener('DOMContentLoaded', executeOnceOnDomContentLoaded);
}

if(document.querySelector(".price_request_btn") != undefined){
document.querySelector(".price_request_btn").addEventListener("click", function() {
  document.querySelector(".price_request_popup").classList.add("active");
});
}

if(document.querySelector(".price_request_popup .site-close-handle") != undefined){
document.querySelector(".price_request_popup .site-close-handle").addEventListener("click", function() {
  document.querySelector(".price_request_popup").classList.remove("active");
});
}

if(document.querySelector(".price_request_popup .popup-background") != undefined){
document.querySelector(".price_request_popup .popup-background").addEventListener("click", function() {
   document.querySelector(".price_request_popup").classList.remove("active");
});
}

if(document.querySelector(".wishlist_request_btn") != undefined){
document.querySelector(".wishlist_request_btn").addEventListener("click", function() {
   document.querySelector('html').classList.remove('kill-overflow');
  document.querySelector('body').classList.remove('sidebar-move');
document.querySelector('.wishlist_drawer').classList.remove('active');
  document.querySelector('.site-overlay').classList.remove('active');
	
			window.inertElems.forEach(elm=>{
				elm.removeAttribute('inert');
			});
  document.querySelector(".wishlist_request_popup").classList.add("active");
});
}

if(document.querySelector(".wishlist_request_popup .site-close-handle") != undefined){
document.querySelector(".wishlist_request_popup .site-close-handle").addEventListener("click", function() {
  document.querySelector(".wishlist_request_popup").classList.remove("active");
});
}

if(document.querySelector(".wishlist_request_popup .popup-background") != undefined){
document.querySelector(".wishlist_request_popup .popup-background").addEventListener("click", function() {
   document.querySelector(".wishlist_request_popup").classList.remove("active");
});
}


document.addEventListener("DOMContentLoaded", function() {
      var str1 = window.location.href;
    var str2 = "contact_posted=true#popup-contact-form";
    if (str1.indexOf(str2) !== -1) {
      var message = document.querySelectorAll('.main-product .prodct_page_success_alert');
      for(var i = 0; i < message.length; i++){
        message[i].style.display = 'block';
      }
    }
});
 
function wishlist_add(){

    var wishlist_item = document.querySelectorAll('.wishlist_products .wishlist_products_wrapper .cart-item');
    for(var i = 0; i < wishlist_item.length; i++){
    wishlist_item[i].remove();
    }
    
    document.querySelector('.empty_wishlist').classList.remove('hide');
    document.querySelector('.wishlist_products_wrapper').classList.add('hide');
  document.querySelector('.wishlist_request_btn_wrapper').classList.add('hide');
  
    if (!localStorage.getItem('wishlist')) {
    return;
  }

  const wishlistItems = JSON.parse(localStorage.getItem('wishlist'));
  if (!wishlistItems.length) {
    return;
  }

  document.querySelector('.empty_wishlist').classList.add('hide');
  document.querySelector('.wishlist_products_wrapper').classList.remove('hide');
  document.querySelector('.wishlist_request_btn_wrapper').classList.remove('hide');

   wishlistItems.forEach((item, index) => {
      fetch(`/products/${item}.json`)
      .then((response) => response.json())
      .then(({ product }) => {

        function formatMoney(cents, format) {

			if (typeof cents === 'string') {
				cents = cents.replace('.', '');
			}
	
			let value = '';
			const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
			const formatString = format || moneyFormat;
	
			function formatWithDelimiters(number, precision, thousands, decimal) {
				thousands = thousands || ',';
				decimal = decimal || '.';
	
				if (isNaN(number) || number === null) {
					return 0;
				}
	
				number = (number / 100.0).toFixed(precision);
	
				const parts = number.split('.');
				const dollarsAmount = parts[0].replace(
					/(\d)(?=(\d\d\d)+(?!\d))/g,
					'$1' + thousands
				);
				const centsAmount = parts[1] ? decimal + parts[1] : '';
	
				return dollarsAmount + centsAmount;
			}
	
			switch (formatString.match(placeholderRegex)[1]) {
				case 'amount':
					value = formatWithDelimiters(cents, 2);
					break;
				case 'amount_no_decimals':
					value = formatWithDelimiters(cents, 0);
					break;
				case 'amount_with_comma_separator':
					value = formatWithDelimiters(cents, 2, '.', ',');
					break;
				case 'amount_no_decimals_with_comma_separator':
					value = formatWithDelimiters(cents, 0, '.', ',');
					break;
				case 'amount_no_decimals_with_space_separator':
					value = formatWithDelimiters(cents, 0, ' ');
					break;
				case 'amount_with_apostrophe_separator':
					value = formatWithDelimiters(cents, 2, "'");
					break;
			}
	
			return formatString.replace(placeholderRegex, value);
	
		}

            if(product.variants[0].price == 0){
              var variant_price = '<div class="price_on_request_text">Our price: On request</div>';
            }else{
              if(product.variants[0].compare_at_price > product.variants[0].price){
              var variant_price = '<span class="visually-hidden">Regular price</span><strong>Our price: ' + formatMoney(product.variants[0].price, KROWN.settings.shop_money_format) + '</strong><span class="visually-hidden">Sale price</span><del>'+ formatMoney(product.variants[0].compare_at_price, KROWN.settings.shop_money_format) +'</del>';  
              }else{
              var variant_price = '<span class="visually-hidden">Regular price</span><strong>Our price: ' + formatMoney(product.variants[0].price, KROWN.settings.shop_money_format) + '</strong>';
              }
            } 


        if(product.images[0] != undefined){
          var product_image = '<figure class="lazy-image-small" style="padding-top: 120.00048000192001%"><img src="'+ product.images[0].src +'&amp;width=480" alt="'+ product.images[0].alt +'"  loading="lazy" class="lazy lazyloaded"></figure>';
        }else{
          var product_image = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5"><path d="M330.3 251.9h-4.8c-1.8-11-6.1-21.1-12.4-29.7v-.6l-6.2-23.5c-1.3-5.1-5.9-8.6-11.1-8.6h-8.5l-1.4-4.8c-.7-2.4-2.8-4-5.3-4h-46.3c-2.5 0-4.6 1.6-5.3 4l-1.4 4.8H219c-5.2 0-9.8 3.5-11.1 8.6l-6.2 23.5c-.1.2-.1.4 0 .6-8.4 11.4-13.3 25.5-13.3 40.6 0 15.2 4.9 29.2 13.3 40.6v.6l6.2 23.5c1.3 5.1 5.9 8.6 11.1 8.6h8.5l1.4 4.8c.7 2.3 2.9 4 5.3 4h46.3c2.5 0 4.6-1.6 5.3-4l1.4-4.8h8.4c5.2 0 9.8-3.5 11.1-8.6L313 304c.1-.2.1-.4 0-.6 6.3-8.6 10.7-18.7 12.4-29.7h4.8c3.8 0 6.9-3.1 6.9-6.9v-8.1c0-3.8-3.1-6.8-6.8-6.8zm-119.7-53.2c1-3.8 4.4-6.5 8.4-6.5h9.5c.2 0 .3 0 .5-.1.1 0 .3.1.4.1h12.1c.8 0 1.4-.6 1.4-1.4 0-.8-.6-1.4-1.4-1.4h-11.1l1.2-4c.3-1.2 1.4-1.9 2.6-1.9h46.3c1.2 0 2.2.8 2.6 1.9l1.2 4h-11.1c-.8 0-1.4.6-1.4 1.4 0 .8.6 1.4 1.4 1.4h12.1c.2 0 .3 0 .4-.1.2.1.3.1.5.1h9.5c3.9 0 7.4 2.7 8.4 6.5l4.8 18.3c-12.6-14.2-31-23.2-51.5-23.2s-38.9 9-51.5 23.2l4.7-18.3zm46.7-2c36.4 0 66.1 29.7 66.1 66.1 0 36.4-29.7 66.1-66.1 66.1s-66.1-29.7-66.1-66.1c0-36.5 29.7-66.1 66.1-66.1zM304 326.8c-1 3.8-4.4 6.5-8.4 6.5h-22.5c-.8 0-1.4.6-1.4 1.4s.6 1.4 1.4 1.4h11.1l-1.2 4c-.3 1.2-1.4 1.9-2.6 1.9h-46.3c-1.2 0-2.3-.8-2.6-1.9l-1.2-4h11.1c.8 0 1.4-.6 1.4-1.4s-.6-1.4-1.4-1.4H219c-3.9 0-7.4-2.7-8.4-6.5l-4.8-18.3c12.6 14.2 31 23.2 51.5 23.2s38.9-9 51.5-23.2l-4.8 18.3zm30.3-60c0 2.2-1.8 4-4 4h-4.5c.1-.5.1-1 .2-1.6h5.2c.4 0 .7-.3.7-.7s-.3-.7-.7-.7h-5.1c.1-.8.1-1.6.1-2.4h5c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-4.9v-2.4h4.9c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-5c0-.8-.1-1.6-.1-2.4h5.1c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7H326c0-.5-.1-1-.2-1.6h4.5c2.2 0 4 1.8 4 4v8z"></path><path d="M257.3 324.5c34 0 61.7-27.7 61.7-61.7s-27.7-61.7-61.7-61.7-61.7 27.7-61.7 61.7 27.7 61.7 61.7 61.7zm0-120.6c32.5 0 58.9 26.4 58.9 58.9s-26.4 58.9-58.9 58.9-58.9-26.4-58.9-58.9 26.5-58.9 58.9-58.9zm26.3 144h-52.5c-.8 0-1.4.6-1.4 1.4v18.8c0 .8.6 1.4 1.4 1.4h52.5c.8 0 1.4-.6 1.4-1.4v-18.8c0-.8-.7-1.4-1.4-1.4zm-1.5 18.8h-49.6v-16h49.6v16zm19.5-28h-12.3c-.8 0-1.4.6-1.4 1.4v15.5c0 .8.6 1.4 1.4 1.4h12.3c.8 0 1.4-.6 1.4-1.4v-15.5c0-.7-.7-1.4-1.4-1.4zm-1.5 15.5h-9.4v-12.6h9.4v12.6zm-74.7-15.5h-12.3c-.8 0-1.4.6-1.4 1.4v15.5c0 .8.6 1.4 1.4 1.4h12.3c.8 0 1.4-.6 1.4-1.4v-15.5c0-.7-.6-1.4-1.4-1.4zm-1.5 15.5h-9.4v-12.6h9.4v12.6zm59.7 19h-52.5c-.8 0-1.4.6-1.4 1.4v18.8c0 .8.6 1.4 1.4 1.4h52.5c.8 0 1.4-.6 1.4-1.4v-18.8c0-.8-.7-1.4-1.4-1.4zm-1.5 18.8h-49.6v-16h49.6v16zm19.5-32.7h-12.3c-.8 0-1.4.6-1.4 1.4v20.1c0 .8.6 1.4 1.4 1.4h12.3c.8 0 1.4-.6 1.4-1.4v-20.1c0-.8-.7-1.4-1.4-1.4zm-1.5 20h-9.4v-17.2h9.4v17.2zm-74.7-20h-12.3c-.8 0-1.4.6-1.4 1.4v20.1c0 .8.6 1.4 1.4 1.4h12.3c.8 0 1.4-.6 1.4-1.4v-20.1c0-.8-.6-1.4-1.4-1.4zm-1.5 20h-9.4v-17.2h9.4v17.2zm77.7 5.3h-12.3c-.8 0-1.4.6-1.4 1.4v7.4c0 .8.6 1.4 1.4 1.4h12.3c.8 0 1.4-.6 1.4-1.4V386c0-.7-.7-1.4-1.4-1.4zm-1.5 7.4h-9.4v-4.5h9.4v4.5zm-74.7-7.4h-12.3c-.8 0-1.4.6-1.4 1.4v7.4c0 .8.6 1.4 1.4 1.4h12.3c.8 0 1.4-.6 1.4-1.4V386c0-.7-.6-1.4-1.4-1.4zm-1.5 7.4h-9.4v-4.5h9.4v4.5zm7.2-214.4h52.5c.8 0 1.4-.6 1.4-1.4v-18.8c0-.8-.6-1.4-1.4-1.4h-52.5c-.8 0-1.4.6-1.4 1.4v18.8c0 .8.6 1.4 1.4 1.4zm1.4-18.8h49.6v16h-49.6v-16zm-19.4 28h12.3c.8 0 1.4-.6 1.4-1.4v-15.5c0-.8-.6-1.4-1.4-1.4h-12.3c-.8 0-1.4.6-1.4 1.4v15.5c0 .7.6 1.4 1.4 1.4zm1.4-15.5h9.4v12.6h-9.4v-12.6zm74.8 15.5h12.3c.8 0 1.4-.6 1.4-1.4v-15.5c0-.8-.6-1.4-1.4-1.4h-12.3c-.8 0-1.4.6-1.4 1.4v15.5c0 .7.6 1.4 1.4 1.4zm1.4-15.5h9.4v12.6h-9.4v-12.6zm-59.6-19h52.5c.8 0 1.4-.6 1.4-1.4v-18.8c0-.8-.6-1.4-1.4-1.4h-52.5c-.8 0-1.4.6-1.4 1.4v18.8c0 .8.6 1.4 1.4 1.4zm1.4-18.8h49.6v16h-49.6v-16zm-19.4 32.7h12.3c.8 0 1.4-.6 1.4-1.4v-20.1c0-.8-.6-1.4-1.4-1.4h-12.3c-.8 0-1.4.6-1.4 1.4v20.1c0 .8.6 1.4 1.4 1.4zm1.4-20h9.4v17.2h-9.4v-17.2zm74.8 20h12.3c.8 0 1.4-.6 1.4-1.4v-20.1c0-.8-.6-1.4-1.4-1.4h-12.3c-.8 0-1.4.6-1.4 1.4v20.1c0 .8.6 1.4 1.4 1.4zm1.4-20h9.4v17.2h-9.4v-17.2zm-77.6-5.3h12.3c.8 0 1.4-.6 1.4-1.4v-7.4c0-.8-.6-1.4-1.4-1.4h-12.3c-.8 0-1.4.6-1.4 1.4v7.4c0 .7.6 1.4 1.4 1.4zm1.4-7.4h9.4v4.5h-9.4v-4.5zm74.8 7.4h12.3c.8 0 1.4-.6 1.4-1.4v-7.4c0-.8-.6-1.4-1.4-1.4h-12.3c-.8 0-1.4.6-1.4 1.4v7.4c0 .7.6 1.4 1.4 1.4zm1.4-7.4h9.4v4.5h-9.4v-4.5z"></path><path d="M277.6 162.6h-25.7c-.4 0-.7.3-.7.7s.3.7.7.7h25.7c.4 0 .7-.3.7-.7s-.3-.7-.7-.7zm-18.1-25.4h-22.6c-.4 0-.7.3-.7.7s.3.7.7.7h22.6c.4 0 .7-.3.7-.7s-.3-.7-.7-.7zm16.3 0h-9.6c-.4 0-.7.3-.7.7s.3.7.7.7h9.6c.4 0 .7-.3.7-.7s-.3-.7-.7-.7zm-39 251.9H273c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-36.2c-.4 0-.7.3-.7.7 0 .3.3.7.7.7zm0-25.4h13.6c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-13.6c-.4 0-.7.3-.7.7 0 .4.3.7.7.7zm20.5-149c.8 0 1.4-.6 1.4-1.4v-6.5c0-.8-.6-1.4-1.4-1.4s-1.4.6-1.4 1.4v6.5c0 .8.6 1.4 1.4 1.4zm0 96.1c-.8 0-1.4.6-1.4 1.4v6.5c0 .8.6 1.4 1.4 1.4s1.4-.6 1.4-1.4v-6.5c.1-.8-.6-1.4-1.4-1.4zm48-48c0 .8.6 1.4 1.4 1.4h6.5c.8 0 1.4-.6 1.4-1.4 0-.8-.6-1.4-1.4-1.4h-6.5c-.7-.1-1.4.6-1.4 1.4zm-96 0c0-.8-.6-1.4-1.4-1.4h-6.5c-.8 0-1.4.6-1.4 1.4 0 .8.6 1.4 1.4 1.4h6.5c.8 0 1.4-.7 1.4-1.4zm90.8-24c.1 0 .2 0 .4-.1l5.8-3.3c.3-.2.5-.6.3-1-.2-.3-.6-.5-1-.3l-5.8 3.3c-.3.2-.5.6-.3 1 .1.3.3.4.6.4zm-85.9 48l-5.8 3.3c-.3.2-.5.6-.3 1 .1.2.4.4.6.4.1 0 .2 0 .4-.1l5.8-3.3c.3-.2.5-.6.3-1s-.6-.5-1-.3zm68.3 18.1c-.2-.3-.6-.5-1-.3-.3.2-.5.6-.3 1l3.4 5.9c.1.2.4.4.6.4.1 0 .2 0 .4-.1.3-.2.5-.6.3-1l-3.4-5.9zm-50.4-84.3c.1.2.4.4.6.4.1 0 .2 0 .4-.1.3-.2.5-.6.3-1L230 214c-.2-.3-.6-.5-1-.3-.3.2-.5.6-.3 1l3.4 5.9zm49.4.3c.1.1.2.1.4.1s.5-.1.6-.4l3.5-6c.2-.3.1-.8-.3-1-.3-.2-.8-.1-1 .3l-3.5 6c-.2.4 0 .8.3 1zm-48.3 83.7c-.3-.2-.8-.1-1 .3l-3.5 6c-.2.3-.1.8.3 1 .1.1.2.1.4.1s.5-.1.6-.4l3.5-6c.1-.4 0-.8-.3-1zm66.4-16.6l5.8 3.4c.1.1.2.1.4.1s.5-.1.6-.4c.2-.3.1-.8-.3-1l-5.8-3.4c-.3-.2-.8-.1-1 .3-.1.4 0 .8.3 1zM215 237.5l-5.8-3.4c-.3-.2-.8-.1-1 .3-.2.3-.1.8.3 1l5.8 3.4c.1.1.2.1.4.1s.5-.1.6-.4c.2-.4.1-.8-.3-1zm8.9 66.9c.2 0 .4-.1.5-.3l31.2-38.1c.5.3 1.1.4 1.6.4h.5l23.7-2.9c2.4-.3 4.7-.9 6.9-1.9l4.1-1.8c.6-.3.9-.9.8-1.5-.1-.6-.6-1.1-1.2-1.2l-4.4-.7c-2.4-.4-4.8-.4-7.1-.1l-20.9 2.6v-27.6c0-4.2-.5-8.4-1.6-12.5-.1-.3-.4-.5-.7-.5-.3 0-.6.2-.7.5-1 4.1-1.6 8.2-1.6 12.4v28.7c-.2.2-.5.4-.7.6-.6.8-.9 1.7-.7 2.7.1.7.4 1.4.9 1.9l-31.2 38.1c-.2.3-.2.8.1 1 .1.1.3.2.5.2zm57-45.5c.9-.1 1.8-.2 2.7-.2 1.1 0 2.2.1 3.3.3-1.9.8-3.8 1.3-5.8 1.6l-23.7 2.9c-.4.1-.9-.3-.9-.7 0-.2 0-.4.2-.6.1-.2.3-.3.5-.3l23.7-3zm-24.4-27.8c0-3 .3-6 .9-9 .6 3 .9 6 .9 9v27.8l-1.4.2c-.1 0-.2.1-.4.1v-28.1zm1.6 132.6h21.1c.4 0 .7-.3.7-.7 0-.4-.3-.7-.7-.7h-21.1c-.4 0-.7.3-.7.7 0 .4.3.7.7.7z"></path></svg>';
        }
 
        var wishlist_product = '<div class="cart-item">'+
        '<a href="/products/'+ product.handle + '" class="thumbnail">'+
        product_image +
        '</a>'+
        '<div class="content">'+
        '<a href="/products/'+ product.handle + '" class="item-title">'+
        '<span class="underline-animation">'+ product.title +'</span>'+
        '</a>'+
        '<div class="item-price text-size--smaller">'+
                  variant_price +
        '</div>'+
        '<div class="actions">'+
        '<a href="javascript:void(0);" class="remove_product_wishlist remove text-size--smallest" title="Remove" data-product-handle="'+ product.handle + '">Remove</a>'+
        '</div></div></div>';

        document.querySelector('.wishlist_products .wishlist_products_wrapper').innerHTML += wishlist_product;
        
      });
   });
}

function wishlist_remove() {
 setTimeout(() => {
        document.querySelectorAll('.remove_product_wishlist').forEach((wishlistItem, ind) => {
        wishlistItem.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          wishlistItem.closest('.cart-item').remove();
          const productHandle = wishlistItem.dataset.productHandle;
          const wishlistItemsNew = JSON.parse(localStorage.getItem('wishlist'));
          localStorage.setItem('wishlist', JSON.stringify(wishlistItemsNew.filter((item) => item !== productHandle)));
        var total_items = JSON.parse(localStorage.getItem("wishlist"));
         document.querySelector('.header_wishlist .wishlist_count').innerHTML = total_items.length;
               if(total_items.length == 1){
      document.querySelector('.wishlist_drawer .wishlist_drawer_count').innerHTML = total_items.length + ' product in your Wishlist';
      }else{
        document.querySelector('.wishlist_drawer .wishlist_drawer_count').innerHTML = total_items.length + ' products in your Wishlist';
      }
          
          if(wishlistItemsNew.length == 1){
              document.querySelector('.empty_wishlist').classList.remove('hide');
              document.querySelector('.wishlist_products_wrapper').classList.add('hide');
            document.querySelector('.wishlist_request_btn_wrapper').classList.add('hide');
          }
          wishlist_unselect_icon();
        });
      });
   }, 1000);
}

function wishlist_unselect_icon() {
  var wishlistItemsNew = JSON.parse(localStorage.getItem('wishlist'));
  var wishlist = document.querySelectorAll('.js-wishlist');
  for(var i = 0; i < wishlist.length; i++){
      var product_handle =  wishlist[i].dataset.productHandle;
      var wishlist_found = false;
      for(var j = 0; j < wishlistItemsNew.length; j++){
        if(product_handle == wishlistItemsNew[j]){
           wishlist_found = true;
            break;
        }
      }
    if(wishlist_found == false){
     wishlist[i].classList.remove("added");
    }
  }
}

document.querySelector('.header_wishlist_link').addEventListener('click', function(event) {
 document.querySelector('html').classList.add('kill-overflow');
  document.querySelector('body').classList.add('sidebar-move');
  document.querySelector('.wishlist_drawer').style.display = "block";
  document.querySelector('.site-overlay').classList.add('active');
    setTimeout(()=>{
         document.querySelector('.wishlist_drawer').classList.add('active');
        window.inertElems.forEach(elm=>{
            elm.setAttribute('inert', '');
        });
    }, 10);
});

document.querySelector('.wishlist_drawer_close').addEventListener('click', function(event) {
 document.querySelector('html').classList.remove('kill-overflow');
  document.querySelector('body').classList.remove('sidebar-move');
document.querySelector('.wishlist_drawer').classList.remove('active');
  document.querySelector('.site-overlay').classList.remove('active');
	
			window.inertElems.forEach(elm=>{
				elm.removeAttribute('inert');
			});
            // setTimeout(()=>{
            //              document.querySelector('.wishlist_drawer').style.display = "block";
            // }, 250);
});

document.querySelector('.site-overlay').addEventListener('click', function(event) {
 document.querySelector('html').classList.remove('kill-overflow');
  document.querySelector('body').classList.remove('sidebar-move');
document.querySelector('.wishlist_drawer').classList.remove('active');
  this.classList.remove('active');
	
			window.inertElems.forEach(elm=>{
				elm.removeAttribute('inert');
			});
            // setTimeout(()=>{
            //              document.querySelector('.wishlist_drawer').style.display = "block";
            // }, 250);
});

var wishlist = document.querySelectorAll('.js-wishlist');
for(var i = 0; i < wishlist.length; i++){
    const product_handle =  wishlist[i].dataset.productHandle;
    const store_wishlist = localStorage.getItem("wishlist");
     if (store_wishlist) {
       const wishlist_item = JSON.parse(localStorage.getItem("wishlist"));
       if (wishlist_item.includes(product_handle)) {
          wishlist[i].classList.add("added");
       }
       document.querySelector('.header_wishlist .wishlist_count').innerHTML = wishlist_item.length;

             if(wishlist_item.length == 1){
      document.querySelector('.wishlist_drawer .wishlist_drawer_count').innerHTML = wishlist_item.length + ' product in your Wishlist';
      }else{
        document.querySelector('.wishlist_drawer .wishlist_drawer_count').innerHTML = wishlist_item.length + ' products in your Wishlist';
      }
     }
  
  wishlist[i].addEventListener("click", function(event) {
    const store_wishlist = localStorage.getItem("wishlist");
 if (store_wishlist) {
   if(this.classList.contains('added')){
      // remove from local storage
      const wishlistItems = JSON.parse(localStorage.getItem("wishlist"));
      localStorage.setItem(
        "wishlist",
        JSON.stringify(wishlistItems.filter((item) => item !== product_handle))
      );
       wishlist_unselect_icon();
              var total_items = JSON.parse(localStorage.getItem("wishlist"));
         document.querySelector('.header_wishlist .wishlist_count').innerHTML = total_items.length;
           if(total_items.length == 1){
      document.querySelector('.wishlist_drawer .wishlist_drawer_count').innerHTML = total_items.length + ' product in your Wishlist';
      }else{
        document.querySelector('.wishlist_drawer .wishlist_drawer_count').innerHTML = total_items.length + ' products in your Wishlist';
      }
   }else{
        const wishlistItems = JSON.parse(localStorage.getItem("wishlist"));
        const newArray = [...wishlistItems, product_handle];
        const uniqueArray = newArray.filter((item, index) => {
          return newArray.indexOf(item) === index;
        });

        localStorage.setItem("wishlist", JSON.stringify(uniqueArray));
         this.classList.add("added");
         var total_items = JSON.parse(localStorage.getItem("wishlist"));
         document.querySelector('.header_wishlist .wishlist_count').innerHTML = total_items.length;
           if(total_items.length == 1){
      document.querySelector('.wishlist_drawer .wishlist_drawer_count').innerHTML = total_items.length + ' product in your Wishlist';
      }else{
        document.querySelector('.wishlist_drawer .wishlist_drawer_count').innerHTML = total_items.length + ' products in your Wishlist';
      }
   }
      } else {
        localStorage.setItem("wishlist", JSON.stringify([product_handle]));
          this.classList.add("added");
         var total_items = JSON.parse(localStorage.getItem("wishlist"));
         document.querySelector('.header_wishlist .wishlist_count').innerHTML = total_items.length;
         if(total_items.length == 1){
      document.querySelector('.wishlist_drawer .wishlist_drawer_count').innerHTML = total_items.length + ' product in your Wishlist';
      }else{
        document.querySelector('.wishlist_drawer .wishlist_drawer_count').innerHTML = total_items.length + ' products in your Wishlist';
      }
      }
       wishlist_add();
      wishlist_remove();
  });
}


wishlist_add();

if(localStorage.getItem("wishlist") != null){
    setTimeout(() => {
              var total_items = JSON.parse(localStorage.getItem("wishlist"));
         document.querySelector('.header_wishlist .wishlist_count').innerHTML = total_items.length;
      if(total_items.length == 1){
      document.querySelector('.wishlist_drawer .wishlist_drawer_count').innerHTML = total_items.length + ' product in your Wishlist';
      }else{
        document.querySelector('.wishlist_drawer .wishlist_drawer_count').innerHTML = total_items.length + ' products in your Wishlist';
      }
       
      wishlist_remove();
    }, 1000);
}